import React, { FC, useState } from 'react'

import { Loader2Icon, Send } from 'lucide-react'

import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../../ui/tooltip'
import { Button } from '../../../../../../ui/button'

import { getUserFullName } from '../../../../../../../helpers/helpers'
import { usePaymentActions } from '../../../../../../../hooks/usePaymentActions'

import {
  IUserACH,
  IUserCard,
  IUserInterface,
} from '../../../../../../../models/users/user.interface'

interface SendRequestProps {
  card: IUserCard | IUserACH
  user: IUserInterface | null
  organizer: IUserInterface | null
  size?: 'sm' | 'lg'
}
export const SendRequest: FC<SendRequestProps> = ({ card, user, organizer, size }) => {
  const { onSendPaymentRequest } = usePaymentActions()

  const [sendLoading, setSendLoading] = useState(false)

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          disabled={sendLoading}
          size={size}
          className="relative z-10 p-0 opacity-50 hover:opacity-100 transition-all"
          onClick={async (e) => {
            e.preventDefault()
            setSendLoading(true)
            await onSendPaymentRequest(card, user, organizer)
            setSendLoading(false)
          }}
        >
          {sendLoading ? (
            <Loader2Icon className="animate-spin" />
          ) : (
            <Send className="text-SeabiscuitDark200ThemeColor" />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>Sent request to {user && getUserFullName(user)}</TooltipContent>
    </Tooltip>
  )
}
